import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MUNILY_INPUT_PREVIEW_DEFAULTS } from './input-preview.types';

@Component({
  selector: 'common-input-preview',
  templateUrl: './input-preview.component.html',
  styleUrls: ['./input-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputPreviewComponent implements OnChanges {
  @Input() value: string = MUNILY_INPUT_PREVIEW_DEFAULTS.value;
  @Input() label: string = MUNILY_INPUT_PREVIEW_DEFAULTS.label;
  @Input() valuePrefix: string = MUNILY_INPUT_PREVIEW_DEFAULTS.valuePrefix;
  @Input() valueSuffix: string = MUNILY_INPUT_PREVIEW_DEFAULTS.valueSuffix;
  @Input() showLabel: boolean = MUNILY_INPUT_PREVIEW_DEFAULTS.showLabel;
  @Input() showLeadingIcon: boolean = MUNILY_INPUT_PREVIEW_DEFAULTS.showLeadingIcon;
  @Input() leadingIcon: string = MUNILY_INPUT_PREVIEW_DEFAULTS.leadingIcon;
  @Input() showEditIcon: boolean = MUNILY_INPUT_PREVIEW_DEFAULTS.showEditIcon;
  @Input() borderless: boolean = MUNILY_INPUT_PREVIEW_DEFAULTS.borderless;
  /** When true, clicking the row emits `edit` (even if `showEditIcon` is false). */
  @Input() clickable: boolean = MUNILY_INPUT_PREVIEW_DEFAULTS.clickable;

  @Output() edit = new EventEmitter<void>();

  public containerClasses: string[] = [];

  constructor() {
    this.syncContainerClasses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['borderless'] || changes['clickable']) {
      this.syncContainerClasses();
    }
  }

  onEdit(): void {
    this.edit.emit();
  }

  onClick(): void {
    if (!this.clickable) return;
    this.onEdit();
  }

  private syncContainerClasses(): void {
    const next: string[] = [];
    if (this.borderless) next.push('munily-input-preview--borderless');
    if (this.clickable) next.push('munily-input-preview--clickable');
    this.containerClasses = next;
  }
}
